<template>
    <div class="np-group pt-3 pb-3">
        <button class="np-btn me-2" 
            :class="this.activeTab == 'admin' ? 'np-btn-secondary active' : 'np-outline'"
            @click="switchTo('admin')">
            <svg class="icon"><use href="@/assets/images/icons/stat.svg#icon"></use></svg>
            {{ $t("UI.admin.admin") }}
        </button>
        <button class="np-btn me-2" 
            :class="this.activeTab == 'organization' ? 'np-btn-secondary active' : 'np-outline'" 
            @click="switchTo('organization')">
            <svg class="icon"><use href="@/assets/images/icons/home.svg#icon"></use></svg>
            {{ $t("UI.admin.organization") }}
        </button>
        <button class="np-btn me-2" 
            :class="this.activeTab == 'users' ? 'np-btn-secondary active' : 'np-outline'"
            @click="switchTo('users')">
            <svg class="icon"><use href="@/assets/images/icons/team.svg#icon"></use></svg>
            {{ $t("UI.admin.users") }}
        </button>
        <button class="np-btn" 
            :class="this.activeTab == 'logs' ? 'np-btn-secondary active' : 'np-outline'"
            @click="switchTo('logs')">
            <svg class="icon"><use href="@/assets/images/icons/order.svg#icon"></use></svg>
            {{ $t("UI.admin.logs") }}
        </button>        
    </div>
</template>

<script>

export default {
    props: {
        activeTab: {
            type: String,
            default: "admin",
            required: true
        }
    },    
    methods: {
        switchTo(target) {
            this.$emit("callSwitchScreen", target)
        }        
    }

}
</script>

<style>
</style>